class HeaderSlider extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector(".collection__container--slider");
    this.sliderItems = this.querySelectorAll(".collection__wrapper");
    this.titles = this.querySelectorAll("[data-title-index]");
    this.menuIndex = this.dataset.menuIndex;
    this.titleContainer = this.querySelector(".collection__title-container");

    this.index = 0;
    this.collections = this.querySelectorAll(".collection__swiper--box");
    this.mobileSwiper = null;

    if (this.titles.length > 0) {
      this.setActiveTitle(this.titles[0]);
      this.setActiveTitleState(0);
    }

    this.titles.forEach((title) =>
      title.addEventListener("mouseenter", this.titleListener.bind(this))
    );

    this.titles.forEach((title) =>
      title.addEventListener("click", this.titleListener.bind(this))
    );

    this.initSwiper();
    window.addEventListener("resize", this.handleResize.bind(this));
  }

  handleResize() {
    if (this.titles.length > 0) {
      this.setActiveTitle(this.titles[this.index] || this.titles[0]);
      this.scrollActiveTitleIntoView(this.index, false);
    }
  }

  titleListener(e) {
    const target = e.currentTarget || e.target;
    this.index = parseInt(target.dataset.titleIndex);

    if (this.dataset.mobile) {
      if (this.mobileSwiper) {
        this.mobileSwiper.slideTo(this.index);
      } else {
        const slider = this.querySelector(".collection__container--slider");
        const firstItem = slider ? slider.querySelectorAll("li")[0] : null;

        if (slider && firstItem) {
          const sliderItemWidth = firstItem.clientWidth;
          const translateWidth = "-" + (this.index * sliderItemWidth) + "px";
          const currentSlide = slider.querySelectorAll("li.collection__wrapper")[this.index];
          const sliderItemHeight = currentSlide ? currentSlide.clientHeight : 0;

          slider.style.transition = "transform 0.3s ease";
          slider.style.transform = `translate3d(${translateWidth}, 0px, 0px)`;
          if (sliderItemHeight) {
            slider.style.minHeight = `${sliderItemHeight}px`;
          }
        }
      }
    } else {
      this.setSlidePosition(this.index);
    }

    this.setActiveTitle(target);
    this.setActiveTitleState(this.index);
    this.scrollActiveTitleIntoView(this.index, true);
    this.initSwiper();
  }

  setActiveTitle(activeTitle) {
    const underline = this.querySelector(".active--title");
    if (!underline || !activeTitle) return;

    underline.style.width = `${activeTitle.offsetWidth}px`;
    underline.style.transform = `translateX(${activeTitle.offsetLeft}px)`;
  }

  setActiveTitleState(activeIndex) {
    this.titles.forEach((title, index) => {
      if (index === activeIndex) {
        title.classList.add("active");
        title.style.fontWeight = "700";
      } else {
        title.classList.remove("active");
        title.style.fontWeight = "";
      }
    });
  }

  scrollActiveTitleIntoView(activeIndex, smooth = true) {
    if (!this.titleContainer || !this.titles[activeIndex]) return;

    const activeTitle = this.titles[activeIndex];
    const container = this.titleContainer;

    const containerRect = container.getBoundingClientRect();
    const titleRect = activeTitle.getBoundingClientRect();

    const titleLeftWithinContainer = activeTitle.offsetLeft;
    const targetScrollLeft =
      titleLeftWithinContainer - (container.clientWidth / 2) + (activeTitle.clientWidth / 2);

    const maxScrollLeft = container.scrollWidth - container.clientWidth;
    const clampedScrollLeft = Math.max(0, Math.min(targetScrollLeft, maxScrollLeft));

    const partlyOutLeft = titleRect.left < containerRect.left;
    const partlyOutRight = titleRect.right > containerRect.right;

    if (partlyOutLeft || partlyOutRight || this.dataset.mobile) {
      container.scrollTo({
        left: clampedScrollLeft,
        behavior: smooth ? "smooth" : "auto",
      });
    }
  }

  setSlidePosition(position) {
    const index = Number.parseInt(position, 10);
    const targetItem = this.sliderItems[index];

    if (!this.slider || !targetItem) return;

    const itemCenter = targetItem.offsetLeft + targetItem.offsetWidth / 2;
    const viewportCenter = this.slider.offsetWidth / 2;
    const targetScrollLeft = itemCenter - viewportCenter;
    const maxScrollLeft = this.slider.scrollWidth - this.slider.offsetWidth;
    const clampedScrollLeft = Math.max(0, Math.min(targetScrollLeft, maxScrollLeft));

    this.slider.scrollTo({
      left: clampedScrollLeft,
      behavior: "smooth",
    });
  }

  initSwiper() {
    if (!this.dataset.mobile) return;

    const mobileContainer = this.querySelector(".collection__mobile-container");
    if (!mobileContainer) return;

    if (this.mobileSwiper && !this.mobileSwiper.destroyed) {
      this.mobileSwiper.update();
      return;
    }

    this.mobileSwiper = new Swiper(mobileContainer, {
      init: true,
      direction: "horizontal",
      autoHeight: true,
      slidesPerView: 1,
      spaceBetween: 0,
      observer: true,
      observeParents: true,
    });

    this.mobileSwiper.on("slideChange", this.swiperListener.bind(this));
  }

  swiperListener(e) {
    const currentIndex = e.activeIndex;
    const currentTitle = this.titles[currentIndex];
    this.index = currentIndex;

    this.setActiveTitle(currentTitle);
    this.setActiveTitleState(currentIndex);
    this.scrollActiveTitleIntoView(currentIndex, true);
  }
}

customElements.define("header-slider", HeaderSlider);

// SLIDERS ====================================================================================================
class CollectionSlide extends HTMLElement {
  constructor() {
    super();
    this.swiperWrapper = this.querySelector(".collection-swiper");
    this.space = parseInt(this.dataset.space);
    this.numSlide = parseInt(this.dataset.numberSlide);
    this.slideSize = parseInt(this.dataset.slideSize);
  }

  connectedCallback() {
    this.initSwiper();
  }

  initSwiper() {
    this.swiper = new Swiper(this.swiperWrapper, {
      init: true,
      direction: "horizontal",
      a11y: {
        prevSlideMessage: "Previous slide",
        nextSlideMessage: "Next slide",
      },
      slidesPerView: this.numSlide,
      spaceBetween: this.space,
      preventClicksPropagation: true,
      observer: true,
      grabCursor: true,
      navigation: {
        nextEl: `.swiper-button-next`,
        prevEl: `.swiper-button-prev`,
      },
    });
  }
}

customElements.define("collection-slider", CollectionSlide);

class LinkedComponent extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", this.route.bind(this));
    this.isTouchDevice = this.checkTouchDevice();
    this.collection = document.querySelector("collection-slider");
    window.matchMedia("(pointer: coarse)").addListener(this.handleTouchCapabilityChange.bind(this));
  }

  checkTouchDevice() {
    return window.matchMedia("(pointer: coarse)").matches;
  }

  handleTouchCapabilityChange(event) {
    this.isTouchDevice = event.matches;
    if (this.collection) {
      this.collection.initSwiper();
    }
  }

  route() {
    if (this.isTouchDevice) return;
    window.location = this.dataset.link;
  }
}

customElements.define("linked-component", LinkedComponent);